<template>
  <v-carousel
    class="elevation-0"
    hide-delimiters
    cycle
    interval="25000"
    height="auto"
    light
    @change="onCarouselSelected"
    :key="$vuetify.theme.primaryText"
  >
    <template
      v-for="banner in banners"
    >
      <canvas-item
        :p_animationName="banner"
        :p_isSelected="(banner === selectedItem)"
        :key="banner"
      />
    </template>
  </v-carousel>
</template>

<script>
import CanvasItem from './canvas-item'
import { animationList as banners } from './animations/bannerAnimations'

export default {
  name: 'Banners',
  data () {
    return {
      banners,
      selectedItem: null,
    }
  },
  methods: {
    onCarouselSelected (_id) {
      this.selectedItem = banners[_id]
    },
  },
  components: {
    CanvasItem,
  },
}
</script>
